










import { defineComponent, ref } from '@nuxtjs/composition-api'
/*import { useUiState } from '~/composables';*/

export default defineComponent({

    props: {
        url: {
            type: String,
            required: true
        },
        rootClass: {
            type: String,
            default: ''
        },
        fallbackImage: {
            type: String
        },
        showControls: {
            type: Boolean,
            default: true
        },
        isAutoplay: {
            type: Boolean,
            default: true
        }
    },
    setup(props) {
        const isSSR = ref(true);
        const url = props.url;
        const videoPlayer = ref(null)
        // example url : https://players.brightcove.net/1231248584001/default_default/index.html?videoId=5589126453001
        const merchId = url.split('players.brightcove.net/')[1].split('/default_default')[0]
        const videoId = url.split('?videoId=')[1];
        const properties = {
            autoplay: props.isAutoplay,
            muted: true,
            loop: true,
            playsinline: props.isAutoplay,
            controls: !!props.showControls,
            ...(props.fallbackImage ? { poster: props.fallbackImage } : {})
        }
        return {
            videoPlayer,
            merchId,
            videoId,
            properties,
            isSSR
        }
    },
    mounted() {
        this.isSSR = false;
        console.log('BrightcoveVideo mounted', this.url);
        // @ts-ignore
        if (!!window.videojs) {
            this.initVideoPlayer();
        } else {
            const merchId = this.merchId;
            const script = document.createElement('script');
            script.src = `https://players.brightcove.net/${merchId}/default_default/index.min.js`;
            script.async = true;
            script.onload = () => {
                this.initVideoPlayer();
            };
            document.body.appendChild(script);

        }
    },
    methods: {
        initVideoPlayer() {
            const videoPlayer = this.$el;
            const isAutoplay = this.isAutoplay;
            const videoId = this
            if (!videoPlayer) return;
            //@ts-ignore
            this.videoPlayer = window.videojs(videoPlayer, this.properties);
            this.videoPlayer.ready(() => {
                //console.log('READY::' + this.videoId)
                const player = this.videoPlayer;
                player.on('loadeddata', () => {
                    this.$emit('loaded')
                })
                player.on('play', () => this.$emit('onPlay'));
                player.on('pause', () => this.$emit('onPause'));

                if (isAutoplay) {
                    player.play && player.play()
                };


            });
        },
        
        onLoaded() {
            this.$emit('loaded-data')
        }
    }
})
